import { createContext } from "react"

const AudioSamples = createContext()

export default AudioSamples
